import { render, staticRenderFns } from "./ProjectReprintAndCancellation.vue?vue&type=template&id=273cf936&scoped=true&lang=pug&"
import script from "./ProjectReprintAndCancellation.vue?vue&type=script&lang=ts&"
export * from "./ProjectReprintAndCancellation.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectReprintAndCancellation.vue?vue&type=style&index=0&id=273cf936&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273cf936",
  null
  
)

export default component.exports